module.exports = __webpack_public_path__ + "img/OT814.ccd92a3.jpg";